//  icons
import {
  FiLinkedin,
  FiInstagram,
  FiGithub,
  FiDribbble,
  FiLayout,
  FiSettings,
  FiPenTool,
  FiTag,
  FiMail,
  FiMapPin,
} from "react-icons/fi";

// companies icons
import FreelancerBrandIcon from "./assets/img/brands/freelancer.png";
import UpworkBrandIcon from "./assets/img/brands/upwork.png";
import FiverBrandIcon from "./assets/img/brands/fiverr.png";
import BehanceBrandIcon from "./assets/img/brands/behance.png";
import DribbbleBrandIcon from "./assets/img/brands/dribbble.png";

// projects images
import Project1 from "./assets/img/projects/bellavita.png";
import Project2 from "./assets/img/projects/chatapp2.png";
import Project4 from "./assets/img/projects/timecamp.png";
import Project5 from "./assets/img/projects/tapfin.png";
import Project6 from "./assets/img/projects/tapfinAdmin.png";
import Project7 from "./assets/img/projects/blogApp.png";
// skills images
import SkillImg1 from "./assets/img/skills/html5.png";
import SkillImg2 from "./assets/img/skills/css3.png";
import SkillImg3 from "./assets/img/skills/js.png";
import SkillImg4 from "./assets/img/skills/reactjs.png";

import SkillImg6 from "./assets/img/skills/nodejs.png";
import SkillImg7 from "./assets/img/skills/git.png";
import Chakra from "./assets/img/skills/Chakra.png";
import SkillImg5 from "./assets/img/skills/Bootstrap.png";
import tailwind from "./assets/img/skills/tailwind.png";
import materialui from "./assets/img/skills/materialui.png";
import mongodb from "./assets/img/skills/mongodb.png";
import mongoose from "./assets/img/skills/mongoose.png";
import redux from "./assets/img/skills/redux.png";
import express from "./assets/img/skills/express.png";

import typescript from "./assets/img/skills/typescript.png";
// testimonial images
import TestiImage1 from "./assets/img/testimonials/testimonial-1.webp";
import TestiImage2 from "./assets/img/testimonials/testimonial-2.webp";
import TestiImage3 from "./assets/img/testimonials/testimonial-3.webp";

// navigation
export const navigation = [
  {
    name: "home",
    href: "home",
  },
  {
    name: "about",
    href: "about",
  },
  {
    name: "Skills",
    href: "Skills",
  },
  {
    name: "Projects",
    href: "projects",
  },
  {
    name: "contact",
    href: "contact",
  },
];

// social
export const social = [
  {
    icon: <FiLinkedin />,
    href: "https://www.linkedin.com/in/sandeep-yadav-994a51233/",
  },
  {
    icon: <FiGithub />,
    href: "https://github.com/Sandeep00022",
  },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: "",
  },
  {
    img: UpworkBrandIcon,
    href: "",
  },
  {
    img: FiverBrandIcon,
    href: "",
  },
  {
    img: BehanceBrandIcon,
    href: "",
  },
  {
    img: DribbbleBrandIcon,
    href: "",
  },
];

// projects
export const projectsData = [
  {
    id: "1",
    image: Project5,
    name: "Customer Onboarding System",
    // category: 'UI/UX design',
    description:
      "Customer Onboarding System: A platform that empowers users to apply for loans and leases, specifically tailored for electric vehicles and business ventures. ",
    code: "https://customer.tapfin.in",
    demo: "https://customer.tapfin.in",
    TechStack:
      "TeckStack :React.js || CSS3 || JAVASCRIPT || ChakraUI || Fastify || Node.js || Postgres ",
  },
  {
    id: "2",
    image: Project6,
    name: "Customer Management System",
    // category: 'UI/UX design',
    description:
      "Customer Management System: A platform enabling internal employees to view and update customer details based on assigned permissions while efficiently managing internal company tasks ",
    code: "https://admin.tapfin.in",
    demo: "https://admin.tapfin.in",
    TechStack:
      "TeckStack :React.js || CSS3 || JAVASCRIPT || ChakraUI || Fastify || Node.js || Postgres ",
  },
  {
    id: "3",
    image: Project7,
    name: "Blog Application",
    // category: 'branding',
    description:
      "Blog Application: My Blog Space is a platform where you can discover and read amazing blogs on the latest web development technologies.",
    code: "https://github.com/Sandeep00022/fullstack-blog-app",
    demo: "https://full-stack-blog-app-tdmi.onrender.com/sign-in",
    TechStack:
      "TeckStack : React || React-Redux || Chakra-ui || Tailwind || React-Slick || JavaScript || Node.js || Mongodb || Mongoose || Express",
  },
  {
    id: "4",
    image: Project4,
    name: "Replica of Time camp",
    // category: 'branding',
    description:
      "TimeCamp is a versatile time tracking tool that helps you monitor work hours spent on projects.",
    code: "https://github.com/Sandeep00022/Timecamp-Clone",
    demo: "https://timecampclone.vercel.app/",
    TechStack:
      "TeckStack : React || React-Redux || Chakra-ui || Tailwind || React-Slick || JavaScript || Node.js || Mongodb || Mongoose || Express",
  },
  {
    id: "5",
    image: Project1,
    name: " Replica of Bella Vita",
    // category: 'UI/UX design',
    description:
      "Bella Vita Organic is a leading natural beauty and skincare brand committed to creating handcrafted, natural solutions inspired by the elements of the earth and ancient skin and hair care practices. ",

    code: "https://github.com/Sandeep00022/Bella_vita",
    demo: "https://dreamy-pastelito-30c393.netlify.app/",
    TechStack:
      "TeckStack : JavaScript || Redux || Material-Ui || Bootstrap || Node.js || MongoDb ",
  },
  {
    id: "6",
    image: Project2,
    name: "Chat-Sphere",
    // category: 'UI/UX design',
    description:
      "Chat-Sphere: A versatile chat application that empowers users to engage in both one-on-one conversations and group chats. Authenticated users can seamlessly connect with any other authenticated individual. ",
    code: "https://github.com/Sandeep00022/ChatSphere",
    demo: "https://mychatappp.onrender.com/chats",
    TechStack:
      "TeckStack :React.js || CSS3 || JAVASCRIPT || ChakraUI || Socket.io || Node.js || MongoDb ",
  },
 
];

// projects
export const projectsNav = [
  // {
  //   name: 'all',
  // },
  // {
  //   name: 'UI/UX Design',
  // },
  {
    name: "web development",
  },
  // {
  //   name: 'branding',
  // },
];

// skill
export const skills = [
  {
    image: SkillImg1,
    skill: "HTML5",
  },
  {
    image: SkillImg2,
    skill: "CSS3",
  },
  {
    image: SkillImg3,
    skill: "JavaSript",
  },
  {
    image: SkillImg4,
    skill: "React",
  },
  {
    image: redux,
    skill: "Redux",
  },
  {
    image: SkillImg6,
    skill: "Node.js",
  },
  {
    image: mongodb,
    skill: "Mongodb",
  },
  {
    image: mongoose,
    skill: "Mongoose",
  },
  {
    image: express,
    skill: "Express",
  },
  {
    image: SkillImg7,
    skill: "Git",
  },
  {
    image: Chakra,
    skill: "Chakra",
  },
  {
    image: tailwind,
    skill: "Tailwind",
  },
  {
    image: materialui,
    skill: "Material-UI",
  },
  {
    image: SkillImg5,
    skill: "Bootstrap",
  },
  {
    image: typescript,
    skill: "Typescript",
  },
];

// services
export const services = [
  {
    icon: <FiLayout />,
    name: "Web Design",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.",
  },
  {
    icon: <FiSettings />,
    name: "Web Development",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.",
  },
  {
    icon: <FiPenTool />,
    name: "Branding",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.",
  },
  {
    icon: <FiTag />,
    name: "SEO",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.",
  },
];

// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      "Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.",
    authorName: "Olivia Doe",
    authorPosition: "Head of Design, Google",
  },
  {
    authorImg: TestiImage2,
    authorText:
      "Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.",
    authorName: "Olivia Doe",
    authorPosition: "Head of Design, Google",
  },
  {
    authorImg: TestiImage3,
    authorText:
      "Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.",
    authorName: "Olivia Doe",
    authorPosition: "Head of Design, Google",
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: "Have a question?",
    subtitle: "I am here to help you.",
    description: "Email me at sy344942@gmail.com",
  },
  {
    icon: <FiMapPin />,
    title: "Current Location",
    subtitle: "Nangloi, 110086, New Delhi",
  },
  {
    icon: <FiLinkedin />,
    title: "Linkedin",
    href: "https://www.linkedin.com/in/sandeep-yadav-994a51233/",
  },
  {
    icon: <FiGithub />,

    title: "Github",
    href: "https://github.com/Sandeep00022",
  },
];
